import { useEffect } from "react";
import { useMap } from "react-leaflet";
import CodefixClient from "../../../services/CodefixClient";

const client = new CodefixClient();

export default function CableBboxLoader({
  onData,
}: {
  onData: (rows: any[]) => void;
}) {
  const map = useMap();

  useEffect(() => {
    const fetchVisible = async () => {
      const b = map.getBounds();
      const bbox = [b.getWest(), b.getSouth(), b.getEast(), b.getNorth()].join(
        ","
      );
      const zoom = map.getZoom();
      const rows = await client.receivedCables({ bbox, zoom });
      onData(rows);
    };

    map.on("moveend", fetchVisible);
    fetchVisible();

    return () => {
      map.off("moveend", fetchVisible);
    };
  }, [map, onData]);

  return null;
}
